import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useEffect } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import BlinkingText from './styled/BlinkingText'
import KycCircularProgress from './styled/KycCircularProgress'
import KycLinearProgress from './styled/KycLinearProgress'
import { speak, t } from '~/utils/narration'
import './styles.css'

const FACE_PROMPTS = {
  LIGHT: { en: 'Checking light', hi: 'रोशनी की जाँच हो रही है' },
  // GLASS: { en: 'Checking glasses', hi: 'चश्मे की जाँच हो रही है' },
  // MASK: { en: 'Checking mask', hi: 'मास्क की जाँच हो रही है' },
  // BLINK: { en: 'Blink your eyes', hi: 'अपनी आँखें झपकाएँ' },
  HAND: { en: 'Raise your hand', hi: 'अपना हाथ उठाएँ' },
}

// Styled component for the Box
const StyledInstructionBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  bottom: '0%',
  height: '40%',
  width: '100%',
  left: '0',
  alignItems: 'center',
  zIndex: 2,
  borderRadius: '30px 30px 0 0',
  boxShadow: '0px -2px 15px 0px rgba(145, 158, 171, 0.24)',
  // padding: '16px 24px',
  backgroundColor: '#FFF',
}))
const StyledTransitionGroup = styled(TransitionGroup)(({ theme }) => ({
  width: '100%',
}))
const KycFaceInstructions = ({
  currentStepData,
  currentStepStatus,
  handleCapture,
  warningMessage,
  faceCountWarningMessage,
  isCompleted,
  isRecording,
  isLoading,
  showSuccessFor,
}) => {
  useEffect(() => {
    if (isLoading) return
    if (isCompleted) {
      speak({ en: 'Now, you can capture your photo', hi: 'अब आप अपनी तस्वीर ले सकते हैं' })
      return
    }
    const prompt = FACE_PROMPTS[currentStepData?.type]
    if (prompt) speak(prompt)
  }, [currentStepData?.type, isCompleted, isLoading])

  return (
    <StyledInstructionBox>
      <StyledTransitionGroup>
        <CSSTransition timeout={500} classNames="fade">
          <div className="kyc-step">
            {isLoading ? (
              <Box sx={{ width: '100%', p: 2 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {isRecording
                    ? t({ en: 'Capturing few photos, please wait...', hi: 'कुछ तस्वीरें ली जा रही हैं, कृपया प्रतीक्षा करें...' })
                    : t({ en: 'Saving, please wait...', hi: 'सेव हो रहा है, कृपया प्रतीक्षा करें...' })}
                </Typography>
                <Typography variant="subtitle1">
                  {t({
                    en: 'Please avoid hitting the back button or refreshing the page during this process.',
                    hi: 'इस प्रक्रिया के दौरान कृपया बैक बटन न दबाएँ या पेज रीफ़्रेश न करें।',
                  })}
                </Typography>
                {isRecording ? <KycCircularProgress /> : <CircularProgress sx={{ marginTop: 6 }} />}
              </Box>
            ) : (
              <>
                {/* {isCompleted ? (
                  <>
                    <Box sx={{ px: 2, py: 2 }}>
                      <Typography variant="h5" fontWeight={600} gutterBottom>
                        Next, we’ll take a few photos of you
                      </Typography>
                      <Typography variant="subtitle1">
                        Keep your face is clearly visible and evenly illuminated, with no mask or
                        glass.
                      </Typography>
                    </Box>
                    <Box
                      position="absolute"
                      bottom={0}
                      width="100%"
                      padding={2}
                      borderTop="1px solid #E0E0E0"
                    >
                      <Button size="large" fullWidth sx={{ py: 1.5 }} onClick={handleCapture}>
                        Capture your photo
                      </Button>
                    </Box>
                  </>
                ) : ( */}
                {!isCompleted && (
                  <Box sx={{}}>
                    <Typography
                      variant="h6"
                      fontWeight={600}
                      py={1}
                      borderBottom="1px solid rgba(0,0,0,0.0)"
                    >
                      {t(currentStepData.name)}
                    </Typography>
                    <KycLinearProgress
                      isDeterminate={currentStepStatus === 'success'}
                      determinateTime={showSuccessFor}
                    />

                    <Box sx={{ pt: 2 }}>
                      {currentStepStatus === 'success' ? (
                        <Box sx={{ px: 2 }}>
                          <img src="/images/like.gif" width="25%" />
                          <Typography variant="h5" fontWeight={600} py={1}>
                            {t(currentStepData.successMessage)}
                          </Typography>
                        </Box>
                      ) : (
                        <>
                          {currentStepData.type === 'LIGHT' && (
                            <img src="/images/light.jpg" width="75%" />
                          )}
                          {/*
                          {currentStepData.type === 'GLASS' && (
                            <img src="/images/glass.jpg" width="75%" />
                          )}
                          {currentStepData.type === 'MASK' && (
                            <img src="/images/mask.jpg" width="75%" />
                          )} */}
                          {/*
                          {currentStepData.type === 'BLINK' && (
                            <Box
                              component="img"
                              src="/gifs/blink.gif"
                              alt="Responsive"
                              sx={{
                                'display': 'block',
                                'margin': '10px auto 0px auto',
                                'width': '180px', // Default width
                                '@media (max-width:1200px)': { width: '150px' }, // Adjust for large screens
                                '@media (max-width:900px)': { width: '190px' }, // Adjust for medium screens
                                '@media (max-width:600px)': { width: '140px' }, // Adjust for small screens
                                '@media (max-width:400px)': { width: '125px' }, // Adjust for extra small screens
                              }}
                            />
                          )} */}
                          {currentStepData.type === 'HAND' && (
                            <img src="/images/hand.png" width="35%" />
                          )}
                          {/* Show warnings */}
                          <>
                            {warningMessage || faceCountWarningMessage ? (
                              <Typography variant="h6" fontWeight={600} py={1}>
                                {warningMessage || faceCountWarningMessage}
                              </Typography>
                            ) : (
                              <BlinkingText textsToBlink={currentStepData.instructions.map(t)} />
                            )}
                          </>
                        </>
                      )}
                    </Box>
                  </Box>
                )}
              </>
            )}
          </div>
        </CSSTransition>
      </StyledTransitionGroup>
    </StyledInstructionBox>
  )
}

export default KycFaceInstructions
